import React, { useContext, useState } from 'react';
import './DashboardHeader.scss';
import { useAuth } from '../../../context/AuthContext';
import { Link, useNavigate } from 'react-router-dom';
import avatar from '../../../assets/images/user.png';
import { MdMenuOpen, MdMenu, MdLightMode, MdDarkMode, MdPerson, MdLogout } from 'react-icons/md';
import logo from '../../../assets/images/logo.png';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import Divider from '@mui/material/Divider';
import { ListSubheader } from '@mui/material';
import moment from 'moment';
import toast from 'react-hot-toast';

import { MyContext } from '../../../pages/Dashboard';

function DashboardHeader() {
    const { user, logout } = useAuth();
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const navigate = useNavigate();

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleAccount = () => {
        setAnchorEl(null);
        navigate('/dashboard/usuario/conta');
    }

    const handleLogout = async () => {
        setAnchorEl(null);
        try {
            const res = await logout();
            if (res && res.status === 200) {
                toast.success(`${res.data.msg}`);
                setTimeout(() => navigate('/login'), 1000);
            } else {
                toast.error(`Falha no logout: ${res?.data?.message || 'Erro ao fazer logout.'}`);
            }
        } catch (err) {
            const errorMessage = err.response?.data?.msg || err.response?.data?.message || 'Erro inesperado ao fazer logout.';
            toast.error(`Erro ao fazer logout: ${errorMessage}`);
        }
    }

    const context = useContext(MyContext);

    const formattedDate = moment.utc(user.ultimoAcesso).format('DD/MM/YYYY [às] HH:mm');

    return (
        <>
            <header className='d-flex align-items-center dashboardHeader'>
                <div className='container-fluid w-100'>
                    <div className='row d-flex align-items-center w-100 flex-row'>
                        <div className='col-sm-2 part1'>
                            <Link to='/dashboard' className='d-flex align-items-center logo'>
                                <img src={logo} alt='logo' />
                            </Link>
                        </div>

                        {context.windowWidth > 992 && (
                            <div className='col-sm-3 d-flex align-items-center part2 res-hide'>
                                <Button
                                    onClick={() => context.setIsToggleSidebar(!context.isToggleSidebar)}
                                    className='rounded-circle'
                                >
                                    {
                                        !context.isToggleSidebar ? <MdMenuOpen /> : <MdMenu />
                                    }
                                </Button>
                            </div>
                        )}

                        <div className='col-sm-7 d-flex align-items-center justify-content-end part3'>
                            <Button
                                onClick={() => context.setThemeMode(!context.themeMode)}
                                className='rounded-circle me-3'                                
                            >
                                {
                                    !context.themeMode ? <MdLightMode /> : <MdDarkMode />
                                }
                            </Button>
                            
                            {context.windowWidth < 992 && (
                                <Button
                                    onClick={() => context.openNav()}
                                    className='rounded-circle me-3'
                                >
                                    <MdMenu />
                                </Button>
                            )}

                            <div className='myAccWrapper'>
                                <Button onClick={handleClick} color='primary blue' className='myAcc d-flex align-items-center'>
                                    <div className='userImg'>
                                        <span className='rounded-circle'>
                                            <img src={user.avatar !== null ? user.avatar : avatar} alt='avatar' />
                                        </span>
                                    </div>

                                    <div className='userInfo'>
                                        <h4>{user.nome}</h4>
                                        <p>{user.email}</p>
                                    </div>
                                </Button>
                                <Menu
                                    anchorEl={anchorEl}
                                    id='account-menu'
                                    open={open}
                                    onClose={handleClose}
                                    onClick={handleClose}
                                    transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                                    anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
                                >
                                    <MenuItem sx={{ fontSize: '14px' }} onClick={handleAccount}>
                                        <ListItemIcon>
                                            <MdPerson fontSize='20px' />
                                        </ListItemIcon>
                                        Conta
                                    </MenuItem>
                                    <MenuItem sx={{ fontSize: '14px' }} onClick={handleLogout}>
                                        <ListItemIcon>
                                            <MdLogout fontSize='20px' />
                                        </ListItemIcon>
                                        Sair
                                    </MenuItem>
                                    <Divider />
                                    <ListSubheader sx={{ fontSize: '10px', lineHeight: 1.5 }}>Último acesso em<br />{formattedDate}</ListSubheader>
                                </Menu>
                            </div>
                        </div>
                    </div>
                </div>
            </header>
        </>
    )
}

export default DashboardHeader
